<template>
  <base-message :message="message" :full-width="false">
    <div v-if="!IClassroom.classmates || !IClassroom.classmates.length"
         class="message-body">
      <p>正在进入教室，请稍候</p>
    </div>
    <div v-if="!deskmate" class="message-body is-block">

      <div class="message-block-content">
        <p class="tip">{{ IClassroom.user.name }} 同学，看你天生丽质，聪慧过人，给你一个选择同桌的机会。 <br>选择一位可爱的 <b class="is-text-link">同桌</b> 陪伴你，学习路上不再孤单。</p>

        <div class="columns is-multiline is-centered">
          <div v-for="user in randomUsers"
               class="column is-narrow"
               @click="selectDeskmate(user)">
            <div class="media select-user">
              <div class="media-left">
                <img class="user-head" :src="$imagePath(user.head_image)" alt="">
              </div>
              <div class="media-content">
                <span class="user-name is-text-small">{{ user.user_name }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div v-else class="message-body">
      <div class="media">
        <div class="media-left">
          <img class="user-head" :src="deskmate.head_image" alt="">
        </div>
        <div class="media-content"><b>{{ deskmate.user_name }}</b> 已成为你的同桌，你们的座位是 A1 和 B1，请尽快就座。</div>
      </div>
    </div>
  </base-message>
</template>

<script>
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import { MessageType } from '@/components/classroom/lib/Message'

const IDE = window['IDE']

export default {
  props: ['message'],
  components: { BaseMessage },
  data () {
    return {
      users: [],
      IClassroom,
      deskmate: null,
      randomUsers: []
    }
  },
  mounted () {
    this.loaded = false
    IClassroom.setDeskmate(null)
    const msg = IClassroom.createMessage('system', MessageType.SYS, {
      text: IClassroom.classmates[1].user_name + '、' + IClassroom.classmates[2].user_name + '等 48 位同学进入教室'
    })
    msg.time = this.message.time - 1
    IClassroom.$emit('message', msg)
    IClassroom.saySomething('系统觉得你天生丽质聪颖，给你一次选择同桌的机会，请选一位你最爱慕的同桌与你一起学习。')
    this.getRandomUser()
  },
  methods: {
    selectDeskmate (deskmate) {
      this.deskmate = deskmate
      IClassroom.requestNextMessage()
      IClassroom.setDeskmate(deskmate)
      IClassroom.saySomething(deskmate.user_name + '已成为你的同桌，请尽快就座。')
      IDE.toggleNav(false)
    },
    getRandomUser () {
      this.randomUsers = []
      const limit = Math.min(5, IClassroom.classmates.length - 1)
      while (this.randomUsers.length < limit) {
        const r = IClassroom.classmates[~~((IClassroom.classmates.length - 1) * Math.random() + 1)]
        if (!this.randomUsers.find((a) => a._id === r._id) && !r.isOpponent) {
          this.randomUsers.push(r)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.choose-teammate {
  margin .5rem !important
  border-radius 8px
}

.media {
  align-items center
}

.tip {
  padding 1rem 0
  text-align center
}

.loading {
  display flex
  flex-direction column
  justify-content center
  align-items center
  border-radius 10px
  min-width 200px
}

.select-user {
  cursor: pointer;
  padding 5px 10px 5px 5px
  border-radius 5px
  margin 5px 0

  &:hover {
    animation focus-wave .8s ease-in-out infinite
  }
}

.user-name {
  margin-top 10px
}

.user-head {
  width 36px
  height 36px
  border 2px solid #dddddd
  border-radius 50%
  overflow hidden
}
</style>
